export default __webpack_public_path__ + "static/media/BoardFill.878a3d5e.svg";